module.exports = __webpack_public_path__ + "static/media/bag.545e1cd9.svg";